import type { ProfileTag as ProfileTagType } from '@/@types/user'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './UserProfileTag.module.css'

export interface UserProfileTagProps extends HTMLAttributes<HTMLDivElement> {
	data: ProfileTagType

	/**
	 * @default 'md'
	 */
	size?: 'sm' | 'md'
}

export default function UserProfileTag({
	data,
	size = 'md',
	className,
	...props
}: UserProfileTagProps) {
	const isRelationshipState =
		data.type === 'MALE_RELATIONSHIP_STATE' || data.type === 'FEMALE_RELATIONSHIP_STATE'

	return (
		<div
			className={clsx(
				styles.root,
				size === 'sm' && styles.rootSmall,
				isRelationshipState && data.type === 'MALE_RELATIONSHIP_STATE' && styles.rootMale,
				isRelationshipState && data.type === 'FEMALE_RELATIONSHIP_STATE' && styles.rootFemale,
				className
			)}
			{...props}
		>
			{data.picUrl && (
				<img src={data.picUrl} className={clsx(styles.icon, size === 'sm' && styles.iconSmall)} />
			)}
			{data.text}
		</div>
	)
}
